<script lang="ts">
    import Icon from "@components_v2/Icon.svelte";
    import NoImageIcon from "@components_v2/Icons/NoImageIcon.svelte";

    import Image from "@components/Image/Image.svelte";

    export let size: "small" | "medium" = "medium";
    export let src: string;
    export let alt: string;

    let error = false;

    const handleError = () => {
        error = true;
    };

    $: iconSize = size === "small" ? 20 : 32;
</script>

<div class="gw-thumbnail gw-thumbnail--{size}">
    {#if !error && src}
        <Image
            {src}
            {alt}
            objectFit="cover"
            on:imageLoadingError={handleError}
            wrapperClassName="gw-thumbnail__image-wrapper"
        />
    {:else}
        <Icon class="gw-thumbnail__icon" width={iconSize} height={iconSize}>
            <NoImageIcon />
        </Icon>
    {/if}
</div>

<style lang="postcss">
    .gw-thumbnail {
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: var(--gw-border-radius-150);
        border: var(--gw-border-width-025) solid var(--gw-border-default);

        &--small {
            width: var(--gw-width-1000);
            height: var(--gw-height-1000);
        }

        &--medium {
            width: var(--gw-width-1600);
            height: var(--gw-height-1600);
        }
    }

    :global(.gw-thumbnail__icon) {
        opacity: 0.33;
    }
    :global(.gw-thumbnail__image-wrapper) {
        width: 100%;
    }
</style>
